/**
 * Crisp.chat live chat widget loader — graceful no-op when env id is absent.
 * Respects cookie consent: only loads when user has accepted "all" (essential-only skips it).
 *
 * Usage: <CrispChat /> mounted once at the App root.
 */
import { useEffect } from "react";

const COOKIE_STORAGE_KEY = "pmpintel_cookie_consent_v1";
const WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;

function consentAllowsLoad() {
  try {
    const raw = localStorage.getItem(COOKIE_STORAGE_KEY);
    if (!raw) return false;
    const { choice } = JSON.parse(raw);
    return choice === "all";
  } catch {
    return false;
  }
}

export default function CrispChat() {
  useEffect(() => {
    if (!WEBSITE_ID || typeof window === "undefined") return;
    if (!consentAllowsLoad()) return;
    if (window.$crisp || document.getElementById("crisp-loader")) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = WEBSITE_ID;
    const script = document.createElement("script");
    script.id = "crisp-loader";
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
